import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IAutoSuggestionList } from "../../../Orchestrator/Types/Interface/ActionParams/RetrieveBookingParams";

class GetAtoSuggestionCacheDataAction extends BaseAction<IDefaultActionResult, void> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const autoSuggestionList: IAutoSuggestionList = {
                bookingReferenceList: [],
                lastNameList: [],
            };
            const cashData = localStorage.getItem("retrieveBookingCacheData");
            if (cashData) {                
                const cashDataObject = JSON.parse(cashData);
                autoSuggestionList.bookingReferenceList = cashDataObject.reference;
                autoSuggestionList.lastNameList = cashDataObject.lastName;
                updateRecoilState("autoSuggestionListAtom", autoSuggestionList);
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const getAtoSuggestionCacheDataAction = new GetAtoSuggestionCacheDataAction()


